import { useMemo, useState } from 'react';

// Ignores changes to defaultValue, but returns the initial default value if the supplied value is falsey
export function useDefault<T>(value: T | undefined, defaultValue: T): T {
  // snap and lock a value for the default ... that way the caller can provide a (changing) literal without
  // re-triggering on a re-render using the default value
  const [fixedDefault] = useState(defaultValue);

  return useMemo(() => value || fixedDefault, [value, fixedDefault]);
}
